import { useState } from 'react';
import * as React from 'react';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.css'
import 'react-toastify/dist/ReactToastify.css';
import './App.scss';
import Navigation from './navigation';
import { ToastContainer } from 'react-toastify';
import { messaging, requestPermissionAndGetToken } from './firebase';
import { onMessage } from 'firebase/messaging';
import { useSelector } from 'react-redux';
import i18n from './i18n/config';
const App = () => {

  React.useEffect(() => {
    requestPermissionAndGetToken();
  }, []);

  const currentLanguage = useSelector((state: any) => state?.profile?.language) || "en";
  React.useEffect(() => {
    if (currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [currentLanguage]);

  React.useEffect(() => {
    navigator.serviceWorker
      .register('/firebase-messaging-sw.js')
      .then((registration) => {

        // Optionally bind the messaging to service worker
        // messaging.useServiceWorker is deprecated in v9+, not needed
      })
      .catch((err) => {
      });



    // ✅ Handle foreground notifications
    const unsubscribe = onMessage(messaging, (payload) => {
      // alert(`Foreground Notification: ${payload.data?.title}`);
      new Notification(payload?.data?.title ?? "Not Found", {
        body: payload.data?.body,
        icon: '/favicon.png',
      });
    });

    return () => {
      unsubscribe(); // Clean up listener on unmount
    };
  }, []);

  // React.useEffect(() => {
  //   onMessageListener().then((payload:any) => {
  //     if (Notification.permission === "granted") {
  //       const { title, body } = payload.data;

  //       new Notification(title, {
  //         body: body,
  //         icon: '/favicon.png', 
  //       });
  //     }
  //   });
  // }, []);

  return (
    <>
      <div className="App">
        <Navigation />
        <ToastContainer />
      </div>
    </>
  );
};
export default App;
